import { createStore } from "vuex";

export default createStore({
  state: {
    ispc: true,
    baseUrls: "https://www.vlygo.cn",
    weburls: "https://www.vlygo.cn",
    casetionIds: "",
    introdusIds1: "",
    introdusIds2: "",
    kcasetionIds: "",
    kintrodusIds1: "",
    kintrodusIds2: "",
    paths:[
      {text:"首页",path:"/",key:"index"},
      {text:"关于我们",path:"/profile",key:"abouts",children:[
        {text:"公司简介",path:"/profile",key:"profile"},
        {text:"企业文化",path:"/cultures",key:"cultures"},
      ]},
      {text:"技术优势",path:"/technical",key:"technical"},
      {text:"应用案例",path:"/caseseries",key:"caseseries",children:[]},
      {text:"产品介绍",path:"/Introduction",key:"Introduction",children:[]},
      {text:"技术培训",path:"/training",key:"training"},
      {text:"知识产权",path:"/property",key:"property"},
      {text:"联系我们",path:"/contacts",key:"contacts"},
    ]
  },
  getters: {
  },
  mutations: {
    setproductlist(state, arrs) {
      var lists=[]
      arrs.forEach(items=>{
        lists.push({
          text: items.title,
          path: "/caseseries?ids="+items.id,
        })
      })
      state.paths[3].children = lists;
    },
    settypelists(state, jsons) {
      var lists=[]
      jsons.arrs.forEach(items=>{
        lists.push({
          text: items.title,
          path: "/Introduction?pid="+jsons.pids+"&ids="+items.id,
        })
      })
      if(jsons.ins==0){
        state.paths[4].children = lists;
      }else{
        state.paths[4].children = [... state.paths[4].children,...lists];
      }
    },
    setispc(state, booles) {
      state.ispc = booles;
    },
  },
  actions: {},
  modules: {},
});
